/* eslint-disable react-refresh/only-export-components --
   Context module: the Provider and its consumer hook belong in one file by
   design. Fast-refresh's component-only-export rule doesn't apply. */
import { createContext, useContext } from 'react';
import type { AuthActions } from './authActions';

const AuthActionsContext = createContext<AuthActions | null>(null);

export const AuthActionsProvider = AuthActionsContext.Provider;

export function useAuthActions(): AuthActions {
  const ctx = useContext(AuthActionsContext);
  if (!ctx) {
    throw new Error('useAuthActions must be used within an AuthActionsProvider');
  }
  return ctx;
}
